<div class="virtual-numeric-keyboard">
    <!-- Render each number in rows of three -->
    <div class="keyboard-row" *ngFor="let row of numberRows">
        <button
            mat-stroked-button
            color="primary"
            *ngFor="let key of row"
            class="key"
            (click)="onKeyPress(key)"
        >
            {{ key }}
        </button>
    </div>
    <!-- Render the utility keys -->
    <div class="keyboard-row">
        <button mat-stroked-button color="warn" class="key special" (click)="onKeyPress('C')">
            C
        </button>
        <button mat-stroked-button color="primary" class="key" (click)="onKeyPress('0')">
            0
        </button>
        <button mat-stroked-button color="warn" class="key special" (click)="onKeyPress('←')">
            ←
        </button>
    </div>

    <!-- Render alphabetic keys -->
    <div class="keyboard-row" *ngFor="let row of alphaRows">
        <button
            mat-stroked-button
            color="primary"
            *ngFor="let key of row"
            class="key alpha"
            (click)="onKeyPress(key)"
        >
            {{ key }}
        </button>
    </div>

    <!-- OK Button Row -->
    <div class="keyboard-row">
        <button mat-raised-button color="accent" class="key ok" (click)="onKeyPress('OK')">
            OK
        </button>
    </div>
</div>
